/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerAddress
 */
export interface PartnerAddress {
    /**
     * 
     * @type {string}
     * @memberof PartnerAddress
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerAddress
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerAddress
     */
    country?: string;
}

/**
 * Check if a given object implements the PartnerAddress interface.
 */
export function instanceOfPartnerAddress(value: object): value is PartnerAddress {
    return true;
}

export function PartnerAddressFromJSON(json: any): PartnerAddress {
    return PartnerAddressFromJSONTyped(json, false);
}

export function PartnerAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'] == null ? undefined : json['street'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function PartnerAddressToJSON(json: any): PartnerAddress {
    return PartnerAddressToJSONTyped(json, false);
}

export function PartnerAddressToJSONTyped(value?: PartnerAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'street': value['street'],
        'zip': value['zip'],
        'city': value['city'],
        'country': value['country'],
    };
}

